import { t } from '@/i18n/translate-utils'
import { MIME_TRANSLATION_KEYS, type SupportedMimeType } from '@/i18n/mime-keys'

/**
 * Returns a human-readable label for a MIME type using i18n translations.
 *
 * Known MIME types are looked up via {@link MIME_TRANSLATION_KEYS}, which lists
 * every supported type as a statically-discoverable {@link asTranslationKey} call
 * so the i18next-parser can extract all keys with `pnpm translate:extract`.
 *
 * Unknown MIME types fall back to a dynamic key with the raw MIME string as
 * the default value.
 *
 * @param mime - The MIME type string (e.g. `"image/jpeg"`, `"application/pdf"`).
 * @returns A localised label such as `"JPEG Image"`, or the raw MIME type when no translation exists.
 */
export function contentTypeToLabel(mime: string): string {
  const key = MIME_TRANSLATION_KEYS[mime as SupportedMimeType] ?? `gallery.mime.${mime}`
  return t(key, mime)
}
